// extracted by mini-css-extract-plugin
export default {"block":"Input_block__VXnDT","error":"Input_error__AS7Wn","input":"Input_input__3vXNu","label":"Input_label__fk9hk","icon":"Input_icon__W-6sp","input_date":"Input_input_date__AYJTg"};